// extracted by mini-css-extract-plugin
export default {"banner":"gFLIwF","banner-img":"Gth6hw","banner-content":"oUA24b","banner-content__icon":"FCgJqs"};